// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
module.exports = {
	//token
	LOGIN_STATUS: 'LOGIN_STATUS_TOKEN',
	UUID:'UUID',
	// uid
	UID:'UID',
	//�û�
	USER_INFO: 'USER_INFO',
	//token�����¼�
	EXPIRES_TIME: 'EXPIRES_TIME',
	//�Ƿ���Ȩ
	WX_AUTH: 'WX_AUTH',
	//���ں���Ȩcode
	STATE_KEY: 'wx_authorize_state',
	//�û�����
	LOGINTYPE: 'loginType',
	//���ں���ת����
	BACK_URL: 'login_back_url',
	// С����code
	STATE_R_KEY: 'roution_authorize_state',
	//��ȨlogoС����
	LOGO_URL: 'LOGO_URL',
	//模板缓存
	SUBSCRIBE_MESSAGE: 'SUBSCRIBE_MESSAGE',
	TIPS_KEY: 'TIPS_KEY',
	SPREAD: 'spread',
	//缓存经度
	CACHE_LONGITUDE: 'LONGITUDE',
	//缓存纬度
	CACHE_LATITUDE: 'LATITUDE',
	CART_ID: 'CART_ID',
	CART_TIME: 'CART_TIME'
}
